import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { appInsights } from '../../AppInsights';
import { ViewEnum } from './ViewEnum';
import { ISearchResult, IDocumentHistory } from '../../intefaces';
import styles from './SearchResults.module.scss';
import { SearchResultsDetail, SearchResultsFlat } from '../../templates';
import { DataService, IDataService } from '../../services';


interface ISearchResultProps {
    searchResult: ISearchResult[];
    searchText: string;
    showResult: boolean;
    viewSelected: string;
}

interface ISearchResultState {
    redirect: boolean;
    id: string;
}

export class SearchResult extends React.Component<ISearchResultProps, ISearchResultState> {
    private _dataService: IDataService = new DataService();

    constructor(props: ISearchResultProps) {
        super(props);

        this.state = {
            redirect: false,
            id: ''
        }
    }

    public render() {
        return (
            <div>
                {this.renderView()}
            </div>
        )
    }

    private selectView(index: any, result: any) {
        if (this.props.viewSelected === ViewEnum.ViewFlat) {
            return <SearchResultsFlat index={index} result={result} clickHandle={(e: any) => this.clickHandle(e, result)} searchText={this.props.searchText} />
        } else {
            return <SearchResultsDetail index={index} result={result} clickHandle={(e: any) => this.clickHandle(e, result)} searchText={this.props.searchText} />
        }
    }

    private renderView() {
        let searchQuery = `/documentView?q=${this.props.searchText}&id=${this.state.id}`;
        if (this.props.showResult) {
            if (this.props.searchResult[0].count > 0) {
                return (this.props.searchResult[0].searchIndexDoc.map((result, index) => {
                    return (
                        <div key={index}>
                            {
                                this.state.redirect ?
                                    <Redirect key={index} to={searchQuery} /> :
                                    this.selectView(index, result)
                            }
                        </div>
                    )
                }));
            } else {
                return (
                    <div className={styles.noResults}>No results were found for <b>{this.props.searchText}</b>. Try removing some filters to expand your search or try another search term.</div>
                );
            }
        } else {
            return <div />
        }
    }

    private clickHandle(event: any, data: any) {
        appInsights.trackEvent({ name: 'document open' }, { key: data.title });
        let searchQuery = `/documentView?q=${this.props.searchText}&id=${data.id}`;
        let documentHistory: IDocumentHistory = { documentTitle: data.title[0], documentUrl: `${window.location.origin}${searchQuery}` };
        this._dataService.CallUpdateDocumentHistory(documentHistory);
        this.setState({
            id: data.id,
            redirect: true
        });

    }
}